import { ROUTE } from "../routes";
import { SizeTypeTokens, WIDGET } from "@voltmoney/schema";
import { addCommasToNumber, addYearToEpochTime } from "../configs/utils";
import { ACTION } from "../partnerWeb_Features/partnerWeb_Dashboard/types";
import { ActiveCustomerTableBuilder, convertISODate, LeadMobileCardBuilder, ReferredPartnerTableBuilder } from "./dashboard/utils";
export const rebuildActiveCustomerTable = async (StandardUtilities, PartnerActiveCustomerData) => {
    await StandardUtilities.setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, 'activeCustomerTable', {
        widgetData: {
            ...ActiveCustomerTableBuilder(PartnerActiveCustomerData).DATA,
        },
        data: PartnerActiveCustomerData,
    });
    const TITLE_CONFIG = ActiveCustomerTableBuilder(PartnerActiveCustomerData).DATA;
    const TABLE_DATA = ActiveCustomerTableBuilder(PartnerActiveCustomerData).TABLE_DATA;
    if (PartnerActiveCustomerData && PartnerActiveCustomerData.length > 0) {
        PartnerActiveCustomerData.map((item, index_i) => {
            TITLE_CONFIG &&
                Object.keys(TITLE_CONFIG).forEach((fieldName, index_j) => {
                    if (fieldName === 'totalValueOfAssetsPledged' ||
                        fieldName === 'approvedCreditAmount' ||
                        fieldName === 'principalOutStandingAmount' ||
                        fieldName === 'overUtilizationAmount' ||
                        fieldName === 'availableCreditAmount') {
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, `AC_AmountStack_${fieldName}_${index_i}`, {
                            label: `₹${addCommasToNumber(TABLE_DATA[index_i][fieldName])}`,
                        });
                    }
                    else if (fieldName === 'createdOn') {
                        const { date, month, year } = convertISODate(TABLE_DATA[index_i][fieldName]);
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, `AC_${fieldName}_${index_i}`, {
                            label: `${date} ${month.slice(0, 3)}, ${year}`,
                        });
                    }
                    else if (fieldName === 'renewalDate') {
                        const { date, month, year } = convertISODate(addYearToEpochTime(TABLE_DATA[index_i][fieldName], 1));
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, `AC_${fieldName}_${index_i}`, {
                            label: `${date} ${month.slice(0, 3)}, ${year}`,
                        });
                    }
                    else if (fieldName === 'phoneNumber') {
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, `AC_${fieldName}_${index_i}`, {
                            label: `${TABLE_DATA[index_i][fieldName]}`
                        });
                    }
                    else if (fieldName === 'customerJourney') {
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, `${fieldName}_${index_i}`, {
                            widgetItems: [
                                { id: `AC_viewDetail_Stack_${fieldName}_${index_i}`, type: WIDGET.STACK },
                            ]
                        });
                        console.log("Set datastore 1: ", `trackbutton_Stack_${fieldName}_${index_i}`, `shareLink_Stack_${fieldName}_${index_i}`, `viewDetail_Stack_${fieldName}_${index_i}`);
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, `AC_trackbutton_Stack_${fieldName}_${index_i}`, {
                            action: {
                                routeId: ROUTE.PLATFORM_ACTIVE_CUSTOMERS,
                                type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
                                payload: {
                                    value: TABLE_DATA[index_i][fieldName],
                                },
                            },
                        });
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, `AC_viewDetail_Stack_${fieldName}_${index_i}`, {
                            action: {
                                routeId: ROUTE.PLATFORM_ACTIVE_CUSTOMERS,
                                type: ACTION.VIEW_DETAILS,
                                payload: {
                                    user: TABLE_DATA[index_i][fieldName],
                                },
                            },
                        });
                    }
                    else {
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, `AC_${fieldName}_${index_i}`, {
                            label: `${TABLE_DATA[index_i][fieldName]}`,
                        });
                    }
                });
        });
    }
};
export const rebuildReferredPartnerTable = async (StandardUtilities, ReferredPartnerData) => {
    await StandardUtilities.setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, 'referredPartnerTable', {
        widgetData: {
            ...ReferredPartnerTableBuilder(ReferredPartnerData).DATA,
        },
        data: ReferredPartnerData,
    });
    const TITLE_CONFIG = ReferredPartnerTableBuilder(ReferredPartnerData).DATA;
    const TABLE_DATA = ReferredPartnerTableBuilder(ReferredPartnerData).TABLE_DATA;
    if (ReferredPartnerData && ReferredPartnerData.length > 0) {
        ReferredPartnerData.map((item, index_i) => {
            TITLE_CONFIG &&
                Object.keys(TITLE_CONFIG).forEach((fieldName, index_j) => {
                    if (fieldName === 'partnerMobileNumber') {
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, `RP_${fieldName}_${index_i}`, {
                            label: `${TABLE_DATA[index_i][fieldName]}`
                        });
                    }
                    else if (fieldName === 'empanelmentDate') {
                        const { date, month, year } = convertISODate(TABLE_DATA[index_i][fieldName]);
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, `RP_${fieldName}_${index_i}`, {
                            label: `${date} ${month.slice(0, 3)}, ${year}`,
                        });
                    }
                    else {
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, `RP_${fieldName}_${index_i}`, {
                            label: `${TABLE_DATA[index_i][fieldName]}`,
                        });
                    }
                });
        });
    }
};
export const rebuildLeadMobileCardBuilder = async (StandardUtilities, mockDATA) => {
    // rebuild the 'leadsMobCardStack'
    await StandardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, 'leadsMobCardStack', {
        widgetItems: [
            ...LeadMobileCardBuilder(mockDATA).WIDGET_STORE,
        ]
    });
    //we want to create the card component for each item
    for (const item of mockDATA) {
        const index = mockDATA.indexOf(item);
        let partnerDetailCardObject = {};
        partnerDetailCardObject = {
            name: item.customerName === null || item.customerName === undefined ? '' : `${item?.customerName}`,
            phoneNumber: item.customerName === null || item.customerName === undefined ? '' : `${item.mobileNumber}`,
            currentStepName: item.applicationStatus === null || item.applicationStatus === undefined ? '' : `${item.applicationStatus}`,
            availableCreditAmount: item.availableLimit === null || item.availableLimit === undefined ? '0' : `${item.availableLimit}`,
            lastUpdatedOn: item.applicationLastUpdateTS === null || item.applicationLastUpdateTS === undefined ? '' : `30th June`,
            userData: item
        };
        await StandardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, `leadsMobDetailsCard_${index}`, {
            title: `${partnerDetailCardObject['name'] ? partnerDetailCardObject['name'] : partnerDetailCardObject['phoneNumber']}`,
            detailItems: [
                { title: 'Status', value: `${partnerDetailCardObject['currentStepName']}` },
                { title: 'Available credit limit', value: partnerDetailCardObject['availableCreditAmount'] !== 'Pending' ? `₹${addCommasToNumber(partnerDetailCardObject['availableCreditAmount'])}` : partnerDetailCardObject['availableCreditAmount'] },
            ],
            actionItems: [
                {
                    title: 'View detail',
                    action: {
                        routeId: ROUTE.PLATFORM_LEADS,
                        type: ACTION.VIEW_DETAILS,
                        payload: {
                            user: partnerDetailCardObject['userData']
                        }
                    }
                },
            ]
        });
        await StandardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, `leadsMobDetailsCardSpace_${index}`, {
            size: SizeTypeTokens.XL
        });
    }
};
export const ReferredPartnerMobileCardBuilder = (mockDATA) => {
    let DATA_STORE = {};
    const WIDGET_STORE = [];
    // we want to create the card component for each item
    mockDATA.forEach((item, index) => {
        let partnerDetailCardObject = {};
        partnerDetailCardObject = {
            partnerName: item?.partnerName ? item?.partnerName : '',
            partnerMobileNumber: item?.partnerMobileNumber
                ? item?.partnerMobileNumber
                : '',
            partnerActivationStatus: item?.partnerActivationStatus,
            empanelmentDate: item?.empanelmentDate
        };
        // for each object we need to create a partner detail card
        WIDGET_STORE.push({ id: `ReferredPartnerMobDetailsCard_${index}`, type: WIDGET.PARTNER_DETAILS_CARD });
        WIDGET_STORE.push({ id: `ReferredPartnerMobDetailsCardSpace_${index}`, type: WIDGET.SPACE });
        const { date, month, year } = convertISODate(partnerDetailCardObject['empanelmentDate']);
        DATA_STORE = {
            ...DATA_STORE,
            [`ReferredPartnerMobDetailsCard_${index}`]: {
                title: `${partnerDetailCardObject['partnerName']}`,
                detailItems: [
                    { title: 'Contact no', value: `${partnerDetailCardObject['partnerMobileNumber']}` },
                    { title: 'Status', value: `${partnerDetailCardObject['partnerActivationStatus']}` },
                    { title: 'Date of empanelment', value: `${date} ${month.slice(0, 3)} ${year}` },
                ],
                actionItems: []
            },
            [`ReferredPartnerMobDetailsCardSpace_${index}`]: {
                size: SizeTypeTokens.XL
            }
        };
    });
    return { WIDGET_STORE, DATA_STORE };
};
